import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "24",
  fill: "none",
  viewBox: "0 0 22 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.333 24H1.667a1.15 1.15 0 0 1-.825-.352A1.22 1.22 0 0 1 .5 22.8V1.2C.5.882.623.577.842.351A1.15 1.15 0 0 1 1.667 0h18.666c.31 0 .607.126.825.351.22.226.342.53.342.849v21.6c0 .318-.123.624-.342.848a1.15 1.15 0 0 1-.825.352M5.167 4.8v4.8h4.666V4.8zm0 7.2v2.4h11.666V12zm0 4.8v2.4h11.666v-2.4zm7-10.8v2.4h4.666V6z"
    }, null, -1)
  ])))
}
export default { render: render }